import { useSnackbar } from 'notistack';
import { Dispatch, useEffect, useRef } from 'react';
import { deleteSiteProcess } from '../../../../apicalls/attendanceManages';
import { checkResData } from '../../../../utils/common';
import { createGanttResourceAndEvent } from '../../../../utils/attendancePage';
import { useRecoilState } from 'recoil';
import {
  attendanceAssignTotallOfDate,
  attendanceGanttData
} from '../../../../GlobalState';

export type Props = {
  isOpen: boolean;
  setIsEditModalOpen: Dispatch<boolean>;
  setIsOpen: Dispatch<boolean>;
  id: number;
  constructId: number;
  getValues: any;
};

export const useHooks = (props: Props) => {
  // snackbar
  const { enqueueSnackbar } = useSnackbar();

  const { isOpen, setIsEditModalOpen, setIsOpen, id, constructId, getValues } =
    props;

  // 送信可能フラグ 多重送信対策
  const isSubmitable = useRef(false);

  const [, setInitialGanttData] = useRecoilState(attendanceGanttData);
  const [, setAssignTotallOfDate] = useRecoilState(
    attendanceAssignTotallOfDate
  );

  const submit = () => {
    if (!isSubmitable.current) return;

    isSubmitable.current = false;

    deleteSiteProcess(id).then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then(async (data: any) => {
        if (data) {
          setIsOpen(false);
          setIsEditModalOpen(false);
          const { resources, events, attendanceManageEventList } =
            await createGanttResourceAndEvent(
              constructId,
              enqueueSnackbar,
              getValues('start_date'),
              getValues('end_date')
            );
          setAssignTotallOfDate(attendanceManageEventList);
          setInitialGanttData({
            resources,
            events
          });
        } else {
          isSubmitable.current = true;
        }
      });
    });
  };

  // キャンセル時の処理
  const cancelSubmit = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      isSubmitable.current = true;
    }
  }, [isOpen]);

  return {
    submit,
    cancelSubmit
  };
};
